<div class="wrapper-submenu">
  <ul class="submenu" *ngIf="currentCollection">
    <h4 style="padding: 20px 10px; margin-bottom: 0;">{{currentCollection.title}}</h4>
    <li (click)="pickCollection('todos');" [class.active]="context == 'todos'">
      Todos
      <span
        class="chip">{{currentCollection.totalresources?.Webresource + currentCollection.totalresources?.Websection }}</span>
    </li>
    <li (click)="pickCollection(item.name);" [hidden]="item.total == 0"
      *ngFor="let item of currentCollection.summary; let i = index"
      [class.active]="context == item.name">
      {{item.title.es}}
      <span class="chip">{{item.total}}</span>
    </li>
  </ul>
</div>


<div infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()" style="min-height: calc(100vh - 100px);">
  <div class="wrapper-content-splitted  hidden-md-up" style="margin-top: 20px;">
    <div class="filter-panel" *ngIf="currentCollection">
      <h2>{{currentCollection.title}}</h2>
    </div>
    <div class="filter-panel" *ngIf="currentCollection">
      <div ngbDropdown class="d-inline-block app-dropdown-menu float-left">
        <button class="btn btn-dark" id="dropdownBasic1" ngbDropdownToggle>
          <span style="color:white" *ngFor="let item of webcontext"
            [hidden]="item.name != context">{{item.title.es}}</span>
          {{context=='todos'?'Todos':''}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="pickCollection('todos');">Todos</button>
          <button ngbDropdownItem (click)="pickContext(item);" [hidden]="item.total == 0"
            *ngFor="let item of currentCollection.summary; let i = index">
            {{item.title.es}} <span class="chip">{{item.total}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper-content-splitted" *ngIf="blog && pag.total>0" style="margin-top: 20px;">
    <div class="filter-panel" *ngIf="pag.total>0">
      <h5 class="ts-color-5" style="padding: 15px;">
        {{pag.from}} - {{pag.to}} de {{pag.total}}</h5>
    </div>
    <div class="filter-panel">
      <input type="text" name="search" (change)="onchange($event)" placeholder="Buscar" class="form-control dark">
    </div>
    <ul class="pagination">
      <li class="pagination-item" *ngFor="let item of pag.list">
        <a class="pagination-btn" (click)="loadContent(item.value)" [hidden]="item.hidden==true"
          [class.active]="item.value == pag.page">
          {{item.label}}
        </a>
      </li>
    </ul>
  </div>

  <div class="wrapper-content-splitted" *ngIf="blog && collection!='Ficha-digital'">
    <div class="wwf-box-min" *ngFor="let card of blog">
      <a class="wwf-card-min" target="{{(card.webcollection_id===9)?'_blank':'_self'}}" href="{{(card.webcollection_id===9)?card.link:'recursos-formulario/'+card.id}}">
        <div class="wwf-card-min-thumb" role="img"
        [attr.aria-label]="card.altimage" [style.background]="'url('+api.getImageUrl(card.image)+')'"></div>
        <div class="wwf-card-min-body">
          <p class="min-title">{{card.name}}</p>
          <p class="min-tag ts-color-5">{{card.webcontext?.title.es}}</p>
        </div>
        <div class="wwf-card-min-btn ts-background-5">
          <svg *ngIf="card.webcollection_id != '9' && card.webcollection_id != '10'" xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
            <g id="descarga" transform="translate(-80 -440)">
              <path id="Trazado_25" data-name="Trazado 25"
                d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z"
                fill="#fff" />
              <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429"
                transform="translate(94.286 440)" fill="#fff" />
            </g>
          </svg>

          <svg *ngIf="card.webcollection_id == '9' || card.webcollection_id == '10'" id="Layer_1" style="width: 50%;" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><defs><style>.cls-1{fill:#fff;}</style></defs><title>icon-youtube</title><path class="cls-1" d="M35.29,45.36V32.69L47.84,39Z"/><path class="cls-1" d="M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0ZM63.15,49.6c-.63,3.79-2.54,5.57-6.38,5.71-8.72.31-17.45.36-26.18.47-2.24,0-4.5,0-6.74-.19-4.54-.31-6.63-1.9-7.07-6.41-.5-5.08-.44-10.22-.45-15.33a22.6,22.6,0,0,1,.8-5.4,5.73,5.73,0,0,1,5.59-4.67c5.9-.32,28.16-.33,33.38-.24,4.15.07,6.38,1.82,7.07,5.92A61,61,0,0,1,63.15,49.6Z"/></svg>
        </div>
      </a>
    </div>
  </div>
  <div class="wrapper-content-splitted" *ngIf="blog && collection=='Ficha-digital'">
    <div class="wwf-box-min" *ngFor="let card of blog">
      <div class="wwf-card-min" (click)="route.goTo('recurso-bosni/'+card.name)">
        <div class="wwf-card-min-thumb" role="img"
        [attr.aria-label]="card.altimage" [style.background]="'url('+api.getImageUrl(card.image)+')'"></div>
        <div class="wwf-card-min-body">
          <p class="min-title">{{card.title.es}}</p>
          <p class="min-tag ts-color-5">{{card.webcontext?.title.es}}</p>
        </div>
        <div class="wwf-card-min-btn ts-background-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
            <g id="descarga" transform="translate(-80 -440)">
              <path id="Trazado_25" data-name="Trazado 25"
                d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z"
                fill="#fff" />
              <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429"
                transform="translate(94.286 440)" fill="#fff" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-content-splitted" *ngIf="blog">
    <ul class="pagination">
      <li class="pagination-item" *ngFor="let item of pag.list">
        <a class="pagination-btn" (click)="loadContent(item.value)" [hidden]="item.hidden==true"
          [class.active]="item.value == pag.page">
          {{item.label}}
        </a>
      </li>
    </ul>
  </div>
</div>
<!-- <div class="filter-panel">
      <div ngbDropdown class="d-inline-block app-dropdown-menu float-right">
        <button class="btn btn-dark" id="dropdownBasic1" ngbDropdownToggle>
          {{collection? collection.title:'Tipo de contenido'}}
          <span style="color:white" *ngFor="let item of webcollection"
            [hidden]="item.name != collection">{{item.title}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="pickCollection(item);"
            *ngFor="let item of webcollection">{{item.title}}</button>
        </div>
      </div>
    </div> -->
  <!--  <div class="wrapper-content-splitted" *ngIf="blog && collection!='Ficha-digital'">
    <div class="wwf-box" *ngFor="let card of blog">
      <div class="wwf-card" magic [magicCss]="{type:'square'}"
        [style.background]="'url('+api.getImageUrl(card.image)+')'">
        <div class="wwf-card--mask" (click)="route.goTo('recursos-formulario/'+card.id)"
          [style.background]="'url('+api.getImageUrl(card.image)+')'">
        </div>
        <div class="wwf-card--body">
          <h4 class="wwf-card--title">{{card.name}}</h4>
        </div>
        <div class="wwf-card--btn ts-background-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
            <g id="descarga" transform="translate(-80 -440)">
              <path id="Trazado_25" data-name="Trazado 25"
                d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z"
                fill="#fff" />
              <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429"
                transform="translate(94.286 440)" fill="#fff" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-content-splitted" *ngIf="blog && collection=='Ficha-digital'">
    <div class="wwf-box" *ngFor="let card of blog">
      <div class="wwf-card" magic [magicCss]="{type:'square'}"
        [style.background]="'url('+api.getImageUrl(card.image)+')'">
        <a class="wwf-card--mask" (click)="route.goTo('recurso-bosni/'+card.name)"
          [style.background]="'url('+api.getImageUrl(card.image)+')'" target="_blank"></a>
        <div class="wwf-card--body">
          <h4 class="wwf-card--title">{{card.title.es}}</h4>
        </div>
        <div class="wwf-card--btn ts-background-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
            <g id="descarga" transform="translate(-80 -440)">
              <path id="Trazado_25" data-name="Trazado 25"
                d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z"
                fill="#fff" />
              <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429"
                transform="translate(94.286 440)" fill="#fff" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div> -->

<!--
<app-footer></app-footer> -->
